webpackJsonp([267695594480457],{

/***/ 411:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _layout = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Terms = function Terms() {
	  return _react2.default.createElement(
	    _layout.FrameContainer,
	    null,
	    _react2.default.createElement(
	      'section',
	      { className: 'terms' },
	      _react2.default.createElement(
	        'h1',
	        null,
	        '\u5229\u7528\u898F\u7D04'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u3053\u306E\u898F\u7D04\uFF08\u4EE5\u4E0B\u300C\u672C\u898F\u7D04\u300D\u3068\u3044\u3044\u307E\u3059\u3002\uFF09\u306F\u3001\u682A\u5F0F\u4F1A\u793Eabasaku(\u4EE5\u4E0B\u300C\u5F53\u793E\u300D\u3068\u3044\u3044\u307E\u3059\u3002)\u304C\u63D0\u4F9B\u3059\u308B\u30A4\u30F3\u30BF\u30FC\u30CD\u30C3\u30C8\u30B5\u30FC\u30D3\u30B9\u300CFlick!On!TV\u300D(\u4EE5\u4E0B\u300C\u672C\u30B5\u30FC\u30D3\u30B9\u300D\u3068\u3044\u3044\u307E\u3059\u3002\uFF09\u306E\u5229\u7528\u306B\u95A2\u3059\u308B\u6761\u4EF6\u3092\u5B9A\u3081\u308B\u3082\u306E\u3067\u3042\u308A\u3001\u672C\u30B5\u30FC\u30D3\u30B9\u3092\u5229\u7528\u3059\u308B\u3059\u3079\u3066\u306E\u304A\u5BA2\u69D8\uFF08\u4EE5\u4E0B\u300C\u30E6\u30FC\u30B6\u30FC\u300D\u3068\u3044\u3044\u307E\u3059\u3002\uFF09\u306B\u9069\u7528\u3055\u308C\u307E\u3059\u3002\u30E6\u30FC\u30B6\u30FC\u306F\u3001\u672C\u30B5\u30FC\u30D3\u30B9\u3092\u5229\u7528\u3059\u308B\u524D\u306B\u672C\u898F\u7D04\u3092\u3088\u304F\u304A\u8AAD\u307F\u304F\u3060\u3055\u3044\u3002'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '\u7B2C\uFF11\u6761 \u5B9A\u7FA9'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u672C\u898F\u7D04\u306B\u304A\u3044\u3066\u3001\u6B21\u306E\u5404\u53F7\u306B\u63B2\u3052\u308B\u7528\u8A9E\u306E\u610F\u7FA9\u306F\u3001\u5F53\u8A72\u5404\u53F7\u306B\u5B9A\u3081\u308B\u3068\u3053\u308D\u306B\u3088\u308B\u3082\u306E\u3068\u3057\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF08\uFF11\uFF09\u300C\u30B3\u30F3\u30C6\u30F3\u30C4\u300D'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u30E6\u30FC\u30B6\u30FC\u304C\u672C\u30B5\u30FC\u30D3\u30B9\u3092\u901A\u3058\u3066\u30A2\u30AF\u30BB\u30B9\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u308B\u60C5\u5831\uFF08\u6587\u7AE0\u3001\u753B\u50CF\u3001\u52D5\u753B\u3001\u97F3\u58F0\u3001\u97F3\u697D\u3001\u30A4\u30E1\u30FC\u30B8\u3001\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u3001\u30D7\u30ED\u30B0\u30E9\u30E0\u3001\u30B3\u30FC\u30C9\u7B49\u3092\u6307\u3057\u307E\u3059\uFF09\u3092\u3044\u3044\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF08\uFF12\uFF09\u300C\u63D0\u4F9B\u30B3\u30F3\u30C6\u30F3\u30C4\u300D'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u672C\u30B5\u30FC\u30D3\u30B9\u306B\u304A\u3044\u3066\u5F53\u793E\u304C\u30E6\u30FC\u30B6\u30FC\u306B\u5BFE\u3057\u63D0\u4F9B\u3059\u308B\u30B3\u30F3\u30C6\u30F3\u30C4\u305D\u306E\u4ED6\u5168\u3066\u306E\u60C5\u5831\u3092\u3044\u3044\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF08\uFF13\uFF09\u300C\u30E6\u30FC\u30B6\u30FC\u30B3\u30F3\u30C6\u30F3\u30C4\u300D'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u30E6\u30FC\u30B6\u30FC\u304C\u672C\u30B5\u30FC\u30D3\u30B9\u306E\u5229\u7528\u306B\u3042\u305F\u3063\u3066\u5165\u529B\u307E\u305F\u306F\u9001\u4FE1\u3059\u308B\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u3044\u3044\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF08\uFF14\uFF09\u300C\u756A\u7D44\u52D5\u753B\u300D'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u30E6\u30FC\u30B6\u30FC\u304C\u672C\u30B5\u30FC\u30D3\u30B9\u5185\u3067\u95B2\u89A7\u3059\u308B\u52D5\u753B\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u3044\u3044\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '\u7B2C\uFF12\u6761 \u672C\u898F\u7D04\u3078\u306E\u540C\u610F'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF11.\u30E6\u30FC\u30B6\u30FC\u306F\u3001\u672C\u898F\u7D04\u306E\u5B9A\u3081\u306B\u5F93\u3063\u3066\u672C\u30B5\u30FC\u30D3\u30B9\u3092\u5229\u7528\u3057\u306A\u3051\u308C\u3070\u306A\u3089\u305A\u3001\u672C\u898F\u7D04\u306B\u540C\u610F\u3057\u306A\u3044\u9650\u308A\u672C\u30B5\u30FC\u30D3\u30B9\u3092\u5229\u7528\u3067\u304D\u307E\u305B\u3093\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF12.\u30E6\u30FC\u30B6\u30FC\u304C\u3001\u672C\u30B5\u30FC\u30D3\u30B9\u3092\u30B9\u30DE\u30FC\u30C8\u30D5\u30A9\u30F3\u305D\u306E\u4ED6\u306E\u60C5\u5831\u7AEF\u672B\u306B\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3057\uFF0C\u672C\u898F\u7D04\u3078\u306E\u540C\u610F\u624B\u7D9A\u3092\u884C\u3063\u305F\u6642\u70B9\u3067\u3001\u30E6\u30FC\u30B6\u30FC\u3068\u5F53\u793E\u3068\u306E\u9593\u3067\u3001\u672C\u898F\u7D04\u306E\u8AF8\u898F\u5B9A\u306B\u5F93\u3063\u305F\u5229\u7528\u5951\u7D04\uFF08 \u4EE5\u4E0B\u300C\u672C\u5229\u7528\u5951\u7D04\u300D\u3068\u3044\u3044\u307E\u3059\u3002\uFF09\u304C\u6210\u7ACB\u3059\u308B\u3082\u306E\u3068\u3057\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '\u7B2C\uFF13\u6761 \u672A\u6210\u5E74\u8005\u306B\u3088\u308B\u5229\u7528'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF11.\u672A\u6210\u5E74\u8005\u306E\u30E6\u30FC\u30B6\u30FC\u306F\u3001\u6709\u511F\u30B3\u30F3\u30C6\u30F3\u30C4\u306E\u8CFC\u5165\u3092\u542B\u3080\u672C\u30B5\u30FC\u30D3\u30B9\u306E\u5229\u7528\u306E\u4E00\u5207\u306B\u3064\u304D\u3001\u89AA\u6A29\u8005\u7B49\u306E\u6CD5\u5B9A\u4EE3\u7406\u4EBA\u306E\u540C\u610F\u3092\u5F97\u305F\u4E0A\u3067\u672C\u30B5\u30FC\u30D3\u30B9\u3092\u5229\u7528\u3057\u3001\u6CD5\u5B9A\u4EE3\u7406\u4EBA\u306E\u540C\u610F\u306E\u3082\u3068\u672C\u30B5\u30FC\u30D3\u30B9\u3092\u5229\u7528\u3057\u306A\u3051\u308C\u3070\u306A\u308A\u307E\u305B\u3093\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF12.\u5F53\u793E\u306F\u672B\u6210\u5E74\u8005\u306E\u30E6\u30FC\u30B6\u30FC\u306B\u3088\u308B\u6709\u511F\u30B3\u30F3\u30C6\u30F3\u30C4\u306E\u8CFC\u5165\u306B\u3064\u304D\u3001\u5E74\u9234\u306B\u5FDC\u3058\u3066\u5229\u7528\u91D1\u984D\u306E\u4E0A\u9650\u307E\u305F\u306F\u652F\u6255\u65B9\u6CD5\u7B49\u306E\u5236\u9650\u3092\u8A2D\u3051\u308B\u3053\u3068\u304C\u3042\u308A\u307E\u3059\u3002\u672A\u6210\u5E74\u8005\u306E\u30E6\u30FC\u30B6\u30FC\u306F\u5F53\u8A72\u5236\u9650\u306B\u5F93\u3063\u3066\u6709\u511F\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u5229\u7528\u3057\u306A\u3051\u308C\u3070\u306A\u308A\u307E\u305B\u3093\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF13.\u672B\u6210\u5E74\u8005\u306E\u30E6\u30FC\u30B6\u30FC\u304C\u3001\u6CD5\u5B9A\u4EE3\u7406\u4EBA\u306E\u540C\u610F\u304C\u306A\u3044\u306B\u3082\u304B\u304B\u308F\u3089\u305A\u540C\u610F\u304C\u3042\u308B\u3068\u507D\u308A\u307E\u305F\u306F\u5E74\u9F62\u306B\u3064\u3044\u3066\u6210\u5E74\u3068\u507D\u3063\u3066\u672C\u30B5\u30FC\u30D3\u30B9\u3092\u5229\u7528\u3057\u305F\u5834\u5408\u3001\u305D\u306E\u4ED6\u884C\u70BA\u80FD\u529B\u8005\u3042\u308B\u3053\u3068\u3092\u4FE1\u3058\u3055\u305B\u308B\u305F\u3081\u306B\u8A50\u8853\u3092\u7528\u3044\u305F\u5834\u5408\u3001\u672C\u30B5\u30FC\u30D3\u30B9\u306B\u95A2\u3059\u308B\u4E00\u5207\u306E\u6CD5\u5F8B\u884C\u70BA\u3092\u53D6\u308A\u6D88\u3059\u3053\u3068\u306F\u51FA\u6765\u307E\u305B\u3093\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF14.\u672C\u898F\u7D04\u306E\u540C\u610F\u6642\u306B\u672A\u6210\u5E74\u3067\u3042\u3063\u305F\u30E6\u30FC\u30B6\u30FC\u304C\u6210\u5E74\u306B\u9054\u3057\u305F\u5F8C\u306B\u672C\u30B5\u30FC\u30D3\u30B9\u3092\u5229\u7528\u3057\u305F\u5834\u5408\u3001\u5F53\u8A72\u30E6\u30FC\u30B6\u30FC\u306F\u672C\u30B5\u30FC\u30D3\u30B9\u306B\u95A2\u3059\u308B\u4E00\u5207\u306E\u6CD5\u5F8B\u884C\u70BA\u3092\u8FFD\u8A8D\u3057\u305F\u3082\u306E\u3068\u307F\u306A\u3055\u308C\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '\u7B2C\uFF14\u6761 \u672C\u898F\u7D04\u306E\u6539\u5B9A\u30FB\u5909\u66F4'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF11.\u5F53\u793E\u306F\u3001\u5F53\u793E\u306E\u5224\u65AD\u306B\u304A\u3044\u3066\u3001\u3044\u3064\u3067\u3082\u672C\u898F\u7D04\u306E\u5185\u5BB9\u3092\u5909\u66F4\u307E\u305F\u306F\u8FFD\u52A0\u3067\u304D\u308B\u3082\u306E\u3068\u3057\u307E\u3059\u3002\u5909\u66F4\u5F8C\u306E\u5229\u7528\u898F\u7D04\u306F\u3001\u5F53\u793E\u304C\u5225\u9014\u5B9A\u3081\u308B\u5834\u5408\u3092\u9664\u3044\u3066\u3001\u672C\u30B5\u30FC\u30D3\u30B9\u4E0A\u307E\u305F\u306F\u3001\u5F53\u793E\u306E\u904B\u55B6\u3059\u308B\u30A6\u30A7\u30D6\u30B5\u30A4\u30C8\u306B\u63D0\u793A\u3057\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '2.\u30E6\u30FC\u30B6\u30FC\u304C\u672C\u898F\u7D04\u306E\u5909\u66F4\u5F8C\u3082\u672C\u30B5\u30FC\u30D3\u30B9\u306E\u5229\u7528\u3092\u7D99\u7D9A\u3059\u308B\u5834\u5408\u3001\u5F53\u8A72\u30E6\u30FC\u30B6\u30FC\u306F\u3001\u5909\u66F4\u5F8C\u306E\u672C\u898F\u7D04\u306B\u540C\u610F\u3057\u305F\u3082\u306E\u3068\u307F\u306A\u3055\u308C\u307E\u3059\u3002\u306A\u304A\u3001\u5F53\u793E\u306F\u3001\u672C\u898F\u7D04\u306E\u5909\u66F4\u307E\u305F\u306F\u8FFD\u52A0\u306B\u3064\u304D\u3001\u5404\u30E6\u30FC\u30B6\u30FC\u306B\u500B\u5225\u306B\u901A\u77E5\u3059\u308B\u3053\u3068\u306F\u3044\u305F\u3057\u307E\u305B\u3093\u3002\u30E6\u30FC\u30B6\u30FC\u306F\u3001\u672C\u30B5\u30FC\u30D3\u30B9\u3092\u3054\u5229\u7528\u3059\u308B\u306B\u3042\u305F\u3063\u3066\u306F\u3001\u968F\u6642\u3001\u672C\u898F\u7D04\u306E\u6700\u65B0\u306E\u5185\u5BB9\u3092\u5FA1\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '\u7B2C\uFF15\u6761 \u30B3\u30F3\u30C6\u30F3\u30C4\u306B\u3064\u3044\u3066'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '1.\u682A\u5F0F\u4F1A\u793Eabasaku\u306F\u3001\u672C\u30B3\u30F3\u30C6\u30F3\u30C4\u306E\u5143\u3068\u306A\u308B\u653E\u9001\u756A\u7D44\u3068\u540C\u7B49\u306E\u5185\u5BB9\u3092\u63D0\u4F9B\u3059\u308B\u3053\u3068\u3092\u4FDD\u8A3C\u3057\u307E\u305B\u3093\u3002\u653E\u9001\u3055\u308C\u305F\u756A\u7D44\u3067\u3042\u3063\u3066\u3082\u3001\u8457\u4F5C\u6A29\u6CD5\u4E0A\u306E\u7406\u7531\u305D\u306E\u4ED6\u306E \u4E8B\u60C5\u306B\u3088\u308A\u672C\u30B5\u30FC\u30D3\u30B9\u3067\u306F\u63D0\u4F9B\u3092\u3057\u306A\u3044\u5834\u5408\u3084\u3001\u672C\u30B5\u30FC\u30D3\u30B9\u3067\u63D0\u4F9B\u3057\u305F\u5F8C\u3067\u3042\u3063\u3066\u3082\u305D\u306E\u63D0\u4F9B\u3092\u4E2D\u6B62\u3059\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002\u307E\u305F\u3001\u8457\u4F5C\u6A29\u6CD5\u4E0A\u306E\u5236\u9650\u307E\u305F\u306F\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u4FDD\u8B77\u7B49\u306E\u305F\u3081\u3001\u653E\u9001\u756A\u7D44\u306E\u4E00\u90E8\u306B\u3064\u3044\u3066\u7DE8\u96C6\u307E\u305F\u306F\u6539\u5909\u3059\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '2.\u672C\u30B3\u30F3\u30C6\u30F3\u30C4\u306E\u8996\u8074\u53EF\u80FD\u671F\u9593\u306F\u7A2E\u985E\u3084\u5185\u5BB9\u306B\u3088\u308A\u7570\u306A\u308A\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '3.\u304A\u5BA2\u69D8\u306F\u3001\u5229\u7528\u6599\u3001\u5229\u7528\u671F\u9593\u7B49\u306E\u5229\u7528\u6761\u4EF6\u304C\u5225\u9014\u5B9A\u3081\u3089\u308C\u305F\u672C\u30B5\u30FC\u30D3\u30B9\u3092\u5229\u7528\u3059\u308B\u5834\u5408\u3001\u304B\u304B\u308B\u5229\u7528\u6761\u4EF6\u306B\u5F93\u3046\u3082\u306E\u3068\u3057\u307E\u3059\u3002\u672C\u30B5\u30FC\u30D3\u30B9\u306E\u753B\u9762\u4E0A\u3067\u300C\u8CFC\u5165\u300D\u3001\u300C\u8CA9\u58F2\u300D\u306A\u3069\u306E\u8868\u793A\u304C\u3055\u308C\u3066\u3044\u308B\u5834\u5408\u3067\u3042\u3063\u3066\u3082\u3001\u5F53\u793E\u304C\u304A\u5BA2\u69D8\u306B\u5BFE\u3057\u63D0\u4F9B\u3059\u308B\u672C\u30B3\u30F3\u30C6\u30F3\u30C4\u306B\u95A2\u3059\u308B\u77E5\u7684\u8CA1\u7523\u6A29\u305D\u306E\u4ED6\u306E\u6A29\u5229\u306F\u304A\u5BA2\u69D8\u306B\u79FB\u8EE2\u305B\u305A\u3001\u304A\u5BA2\u69D8\u306B\u306F\u3001\u4E0A\u8A18\u306E\u5229\u7528\u6A29\u306E\u307F\u304C\u4ED8\u4E0E\u3055\u308C\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '\u7B2C6\u6761 \u901A\u4FE1\u306E\u79D8\u5BC6'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u5F53\u793E\u306F\u3001\u96FB\u6C17\u901A\u4FE1\u4E8B\u696D\u6CD5\u7B2C\uFF14\u6761\u306B\u57FA\u3065\u304D\u3001\u30E6\u30FC\u30B6\u30FC\u306E\u901A\u4FE1\u306E\u79D8\u5BC6\u3092\u5B88\u308A\u307E\u3059\u3002\u305F\u3060\u3057\u3001\u6B21\u306E\u5404\u53F7\u306E\u3044\u305A\u308C\u304B\u4E00\u3064\u306B\u8A72\u5F53\u3059\u308B\u5834\u5408\u3001\u5F53\u793E\u306F\u3001\u5F53\u8A72\u5404\u53F7\u306B\u5B9A\u3081\u308B\u7BC4\u56F2\u5185\u306B\u304A\u3044\u3066\u3001\u30E6\u30FC\u30B6\u30FC\u306E\u901A\u4FE1\u306E\u79D8\u5BC6\u306B\u304B\u304B\u308F\u308B\u60C5\u5831\u3092\u95B2\u89A7\u307E\u305F\u306F\u524A\u9664\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u308B\u3082\u306E\u3068\u3057\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF08\uFF11\uFF09\u5211\u4E8B\u8A34\u8A1F\u6CD5\u307E\u305F\u306F\u72AF\u7F6A\u635C\u67FB\u306E\u305F\u3081\u306E\u901A\u4FE1\u508D\u53D7\u306B\u95A2\u3059\u308B\u6CD5\u5F8B\u306E\u5B9A\u3081\u306B\u57FA\u3065\u304F\u5F37\u5236\u51E6\u5206\u307E\u305F\u306F\u88C1\u5224\u6240\u306E\u547D\u4EE4\u304C\u884C\u308F\u308C\u305F\u5834\u5408'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF08\uFF12\uFF09\u6CD5\u4EE4\u306B\u57FA\u3065\u304F\u884C\u653F\u51E6\u5206\u304C\u5B9F\u65BD\u3055\u308C\u305F\u5834\u5408'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF08\uFF13\uFF09\u7279\u5B9A\u96FB\u6C17\u901A\u4FE1\u5F79\u52D9\u63D0\u4F9B\u8005\u306E\u640D\u5BB3\u8CE0\u511F\u8CAC\u4EFB\u306E\u5236\u9650\u53CA\u3073\u767A\u4FE1\u8005\u60C5\u5831\u306E\u958B\u793A\u306B\u95A2\u3059\u308B\u6CD5\u5F8B\u7B2C\uFF14\u6761\u306B\u57FA\u3065\u304F\u958B\u793A\u8ACB\u6C42\u306E\u8981\u4EF6\u304C\u6E80\u305F\u3055\u308C\u3066\u3044\u308B\u3068\u5F53\u793E\u304C\u5224\u65AD\u3057\u305F\u5834\u5408'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF08\uFF14\uFF09\u4EBA\u306E\u751F\u547D\u3001\u8EAB\u4F53\u307E\u305F\u306F\u8CA1\u7523\u306E\u4FDD\u8B77\u306E\u305F\u3081\u306B\u5FC5\u8981\u304C\u3042\u308B\u3068\u5F53\u793E\u304C\u5224\u65AD\u3057\u305F\u5834\u5408'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF08\uFF15\uFF09\u672C\u30B5\u30FC\u30D3\u30B9\u904B\u55B6\u4E0A\u3084\u3080\u3092\u5F97\u306A\u3044\u3068\u5F53\u793E\u304C\u5224\u65AD\u3057\u305F\u5834\u5408'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF08\uFF16\uFF09\u30E6\u30FC\u30B6\u30FC\u306E\u540C\u610F\u3092\u53D6\u5F97\u3057\u305F\u5834\u5408'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '\u7B2C7\u6761 \u30E6\u30FC\u30B6\u30FC\u306B\u95A2\u3059\u308B\u60C5\u5831\u306E\u53D6\u6271\u3044'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u5F53\u793E\u306F\u3001\u30E6\u30FC\u30B6\u30FC\u60C5\u5831\u3001\u7AEF\u672B\u60C5\u5831\u7B49\u305D\u306E\u4ED6\u672C\u30B5\u30FC\u30D3\u30B9\u306E\u5229\u7528\u306B\u95A2\u3057\u30E6\u30FC\u30B6\u30FC\u304B\u3089\u53CE\u96C6\u3059\u308B\u60C5\u5831\u3092\u3001\u5225\u9014\u5F53\u793E\u304C\u5B9A\u3081\u308BFlick!On!TV\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u30DD\u30EA\u30B7\u30FC\u306B\u5F93\u3044\u3001\u9069\u5207\u306B\u53D6\u308A\u6271\u3044\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '\u7B2C8\u6761 \u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u7BA1\u7406'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF11.\u30E6\u30FC\u30B6\u30FC\u306F\u3001\u81EA\u5DF1\u306E\u8CAC\u4EFB\u306B\u304A\u3044\u3066\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u7BA1\u7406\u53CA\u3073\u4FDD\u7BA1\u3059\u308B\u3082\u306E\u3068\u3057\u3001\u3053\u308C\u3092\u7B2C\u4E09\u8005\u306B\u5229\u7528\u3055\u305B\u3001\u307E\u305F\u306F\u8CB8\u4E0E\u3001\u8B77\u6E21\u3001\u540D\u7FA9\u5909\u66F4\u3001\u58F2\u8CB7\u7B49\u3092\u3057\u3066\u306F\u306A\u3089\u306A\u3044\u3082\u306E\u3068\u3057\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF12.\u5F53\u793E\u306F\u3001\u5F53\u8A72\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u4E00\u81F4\u3092\u78BA\u8A8D\u3057\u305F\u5834\u5408\u3001\u5F53\u6838\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u4FDD\u6709\u3059\u308B\u3082\u306E\u3068\u3057\u3066\u767B\u9332\u3055\u308C\u305F\u30E6\u30FC\u30B6\u30FC\u304C\u672C\u30B5\u30FC\u30D3\u30B9\u3092\u5229\u7528\u3057\u305F\u3082\u306E\u3068\u307F\u306A\u3057\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF13.\u30A2\u30AB\u30A6\u30F3\u30C8\u304C\u76D7\u7528\u3055\u308C\u307E\u305F\u306F\u7B2C\u4E09\u8005\u306B\u4F7F\u7528\u3055\u308C\u3066\u3044\u308B\u3053\u3068\u304C\u5224\u660E\u3057\u305F\u5834\u5408\u3001\u30E6\u30FC\u30B6\u30FC\u306F\u3001\u76F4\u3061\u306B\u305D\u306E\u65E8\u3092\u5F53\u793E\u306B\u901A\u77E5\u3059\u308B\u3068\u3068\u3082\u306B\u3001\u5F53\u793E\u304B\u3089\u306E\u6307\u793A\u306B\u5F93\u3046\u3082\u306E\u3068\u3057\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF14.\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u7BA1\u7406\u4E0D\u5341\u5206\u307E\u305F\u306F\u7B2C\u4E09\u8005\u306E\u4F7F\u7528\u7B49\u306B\u3088\u308B\u640D\u5BB3\u306E\u8CAC\u4EFB\u306F\u3001\u30E6\u30FC\u30B6\u30FC\u304C\u8CA0\u3046\u3082\u306E\u3068\u3057\u3001\u5F53\u793E\u306F\u4E00\u5207\u306E\u8CAC\u4EFB\u3092\u8CA0\u3044\u307E\u305B\u3093\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '5.\u5F53\u793E\u306F\u3001\u6700\u7D42\u306E\u30A2\u30AF\u30BB\u30B9\u304B\u30891\u5E74\u4EE5\u4E0A\u7D4C\u904E\u3057\u3066\u3044\u308B\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u3001\u3042\u3089\u304B\u3058\u3081\u304A\u5BA2\u69D8\u306B\u901A\u77E5\u3059\u308B\u3053\u3068\u306A\u304F\u524A\u9664\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '\u7B2C9\u6761 \u305D\u306E\u4ED6\u306E\u60C5\u5831\u306E\u53D6\u5F97\u53CA\u3073\u5229\u7528\u306B\u3064\u3044\u3066'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u5F53\u793E\u306F\u3001\u672C\u30B5\u30FC\u30D3\u30B9\u306B\u4ED8\u968F\u3059\u308B\u30B5\u30FC\u30D3\u30B9\u306E\u63D0\u4F9B\u306E\u305F\u3081\u306B\u3001\u5F53\u793E\u304C\u53D6\u5F97\u3057\u305F\u60C5\u5831\u306E\u3046\u3061\u3001\u500B\u4EBA\u60C5\u5831\u306B\u8A72\u5F53\u3057\u306A\u3044\u60C5\u5831\u3092\u7D71\u8A08\u60C5\u5831\u3068\u3057\u305F\u3082\u306E\u3092\u7B2C\u4E09\u8005\u306B\u63D0\u4F9B\u3067\u304D\u308B\u3082\u306E\u3068\u3057\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '\u7B2C10\u6761 \u5E83\u544A'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u5F53\u793E\u306F\u3001\u672C\u30B5\u30FC\u30D3\u30B9\u5185\u306B\u5F53\u793E\u307E\u305F\u306F\u7B2C\u4E09\u8005\u306E\u5E83\u544A\u3092\u63B2\u8F09\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u308B\u3082\u306E\u3068\u3057\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '\u7B2C11\u6761 \u672C\u30B5\u30FC\u30D3\u30B9\u306E\u5229\u7528'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF11.\u30E6\u30FC\u30B6\u30FC\u306F\u3001\u5F53\u793E\u306E\u5B9A\u3081\u308B\u65B9\u6CD5\u306B\u5F93\u3044\u3001\u672C\u30B5\u30FC\u30D3\u30B9\u3092\u5229\u7528\u3059\u308B\u3082\u306E\u3068\u3057\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF12.\u672C\u30B5\u30FC\u30D3\u30B9\u306F\u3001\u30E6\u30FC\u30B6\u30FC\u304C\u79C1\u7684\u306B\u4F7F\u7528\u3059\u308B\u76EE\u7684\u3067\u306E\u307F\u5229\u7528\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u3001\u8CA9\u58F2\u3001\u914D\u5E03\u307E\u305F\u306F\u958B\u767A\u7B49\u306E\u79C1\u7684\u4F7F\u7528\u4EE5\u5916\u306E\u76EE\u7684\u3067\u4F7F\u7528\u3057\u3066\u306F\u306A\u308A\u307E\u305B\u3093\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF13.\u30E6\u30FC\u30B6\u30FC\u306F\u3001\u672C\u30B5\u30FC\u30D3\u30B9\u3092\u3001\u5F53\u793E\u304C\u63D0\u4F9B\u3059\u308B\u72B6\u614B\u3067\u306E\u307F\u5229\u7528\u3059\u308B\u3082\u306E\u3068\u3057\u3001\u672C\u30B5\u30FC\u30D3\u30B9\u306E\u8907\u88FD\u3001\u4FEE\u6B63\u3001\u5909\u66F4\u3001\u6539\u5909\u307E\u305F\u306F\u7FFB\u6848\u3092\u884C\u3063\u3066\u306F\u306A\u308A\u307E\u305B\u3093\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF14.\u672C\u30B5\u30FC\u30D3\u30B9\u3092\u5229\u7528\u3059\u308B\u305F\u3081\u306B\u5FC5\u8981\u306A\u60C5\u5831\u7AEF\u672B\u3001\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u3001\u901A\u4FE1\u56DE\u7DDA\u305D\u306E\u4ED6\u306E\u901A\u4FE1\u74B0\u5883\u7B49\u306E\u6E96\u5099\u53CA\u3073\u7DAD\u6301\u306F\u3001\u30E6\u30FC\u30B6\u30FC\u306E\u8CBB\u7528\u3068\u8CAC\u4EFB\u306B\u304A\u3044\u3066\u884C\u3046\u3082\u306E\u3068\u3057\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF15.\u672C\u30B5\u30FC\u30D3\u30B9\u306E\u5168\u90E8\u307E\u305F\u306F\u4E00\u90E8\u306B\u3064\u3044\u3066\u3001\u5E74\u9F62\u3001\u672C\u4EBA\u78BA\u8A8D\u306E\u6709\u7121\u3001\u30E6\u30FC\u30B6\u30FC\u60C5\u5831\u306E\u6709\u7121\u3001\u305D\u306E\u4ED6\u5F53\u793E\u304C\u5FC5\u8981\u3068\u5B9A\u3081\u308B\u6761\u4EF6\u3092\u6E80\u305F\u3057\u305F\u30E6\u30FC\u30B6\u30FC\u306B\u9650\u308A\u5229\u7528\u3067\u304D\u308B\u5834\u5408\u304C\u3042\u308A\u3001\u30E6\u30FC\u30B6\u30FC\u306F\u3042\u3089\u304B\u3058\u3081\u3053\u308C\u306B\u540C\u610F\u3059\u308B\u3082\u306E\u3068\u3057\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '\u7B2C12\u6761 \u7981\u6B62\u884C\u70BA'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF11.\u30E6\u30FC\u30B6\u30FC\u306F\u3001\u672C\u30B5\u30FC\u30D3\u30B9\u306E\u5229\u7528\u306B\u3042\u305F\u308A\u3001\u81EA\u3089\u307E\u305F\u306F\u7B2C\u4E09\u8005\u3092\u3057\u3066\u4EE5\u4E0B\u306E\u540D\u53F7\u306E\u3044\u305A\u308C\u304B\u306B\u8A72\u5F53\u3059\u308B\u884C\u70BA\u307E\u305F\u306F\u8A72\u5F53\u3059\u308B\u304A\u305D\u308C\u306E\u3042\u308B\u884C\u70BA\u3092\u3057\u3066\u306F\u306A\u308A\u307E\u305B\u3093\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '1-1 \u6CD5\u4EE4\u3001\u88C1\u5224\u6240\u306E\u5224\u6C7A\u3001\u6C7A\u5B9A\u82E5\u3057\u304F\u306F\u547D\u4EE4\u3001\u307E\u305F\u306F\u6CD5\u4EE4\u4E0A\u62D8\u675F\u529B\u306E\u3042\u308B\u884C\u653F\u63AA\u7F6E\u306B\u9055\u53CD\u3059\u308B\u884C\u70BA\u307E\u305F\u306F\u3053\u308C\u3089\u3092\u52A9\u9577\u3059\u308B\u884C\u70BA'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '1-2 \u5F53\u793E\u307E\u305F\u306F\u4ED6\u306E\u30E6\u30FC\u30B6\u30FC\u305D\u306E\u4ED6\u306E\u7B2C\u4E09\u8005\u306B\u5BFE\u3059\u308B\u8A50\u6B3A\u307E\u305F\u306F\u8105\u8FEB\u884C\u70BA'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '1-3 \u516C\u5E8F\u826F\u4FD7\u306B\u53CD\u3057\u307E\u305F\u306F\u5584\u826F\u306A\u98A8\u4FD7\u3092\u5BB3\u3059\u308B\u884C\u70BA'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '1-4 \u5F53\u793E\u307E\u305F\u306F\u4ED6\u306E\u30E6\u30FC\u30B6\u30FC\u305D\u306E\u4ED6\u306E\u7B2C\u4E09\u8005\u306E\u77E5\u7684\u8CA1\u7523\u6A29\u3001\u8096\u50CF\u6A29\u3001\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u3001\u540D\u8A89\u3001\u305D\u306E\u4ED6\u306E\u6A29\u5229\u307E\u305F\u306F\u5229\u76CA\u3092\u4FB5\u5BB3\u3059\u308B\u884C\u70BA'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '1-5 \u672C\u30B5\u30FC\u30D3\u30B9\u306E\u8AA4\u4F5C\u52D5\u3092\u8A98\u5F15\u3059\u308B\u884C\u70BA'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '1-6 \u672C\u30B5\u30FC\u30D3\u30B9\u304C\u901A\u5E38\u610F\u56F3\u3057\u306A\u3044\u30D0\u30B0\u3092\u5229\u7528\u3059\u308B\u52D5\u4F5C\u307E\u305F\u306F\u901A\u5E38\u610F\u56F3\u3057\u306A\u3044\u52B9\u679C\u3092\u53CA\u307C\u3059\u5916\u90E8\u30C4\u30FC\u30EB\u306E\u5229\u7528\u3001\u4F5C\u6210\u307E\u305F\u306F\u9812\u5E03\u3092\u884C\u3046\u884C\u70BA'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '1-7 \u672C\u30B5\u30FC\u30D3\u30B9\u307E\u305F\u306F\u5F53\u793E\u30B5\u30FC\u30D0\u30FC\u7B49\u306B\u904E\u5EA6\u306E\u8CA0\u62C5\u3092\u304B\u3051\u308B\u884C\u70BA'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '1-8 \u672C\u30B5\u30FC\u30D3\u30B9\u306E\u5185\u5916\u3092\u554F\u308F\u305A\u3001\u672C\u30B5\u30FC\u30D3\u30B9\u4E0A\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u307E\u305F\u306F\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u7B2C\u4E09\u8005\u306B\u6709\u511F\u3067\u8CB8\u4E0E\u3001\u8B72\u6E21\u3001\u58F2\u8981\u7B49\u3092\u3059\u308B\u884C\u70BA\uFF08\u3044\u308F\u3086\u308B\u30EA\u30A2\u30EB\u30DE\u30CD\u30FC\u30C8\u30EC\u30FC\u30C9\u884C\u70BA\uFF09'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '1-9 \u524D\u53F7\u306B\u5B9A\u3081\u308B\u884C\u70BA\u306E\u7533\u8FBC\u307F\u306E\u8A98\u5F15\u3001\u7533\u8FBC\u307F\u3001\u627F\u8AFE\u3092\u542B\u3080\u4E00\u5207\u306E\u6E96\u5099\u884C\u70BA'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '1-10 \u6B69\u884C\u4E2D\u3001\u8ECA\u4E21\u904B\u8EE2\u4E2D\u3001\u305D\u306E\u4ED6\u306E\u672C\u30B5\u30FC\u30D3\u30B9\u306E\u5229\u7528\u304C\u4E0D\u9069\u5207\u306A\u72B6\u6CC1\u307E\u305F\u306F\u6170\u69D8\u306B\u304A\u3044\u3066\u672C\u30B5\u30FC\u30D3\u30B9\u3092\u5229\u7528\u3059\u308B\u884C\u70BA'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '1-11 \u4EE5\u4E0B\u306B\u8A72\u5F53\u3057\u307E\u305F\u306F\u6838\u5F53\u3059\u308B\u3068\u5F53\u793E\u304C\u5224\u65AD\u3057\u305F\u60C5\u5831\u3092\u672C\u30B5\u30FC\u30D3\u30B9\u4E0A\u306B\u9001\u4FE1\u2022 \u6295\u7A3F\u3059\u308B\u884C\u70BA'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u30A2 \u5F53\u793E\u307E\u305F\u306F\u7B2C\u4E09\u8005\u306E\u8457\u4F5C\u6A29\u305D\u306E\u4ED6\u306E\u77E5\u7684\u8CA1\u7523\u6A29\u3001\u8096\u50CF\u6A29\u3001\u30D7\u30E9\u30A4\u30D1\u30B7\u30FC\u3001\u540D\u8A89\u3001\u305D\u306E\u4ED6\u306E\u6A29\u5229\u307E\u305F\u306F\u5229\u76CA\u3092\u4FB5\u5BB3\u3059\u308B\u60C5\u5831'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u30A4 \u30E6\u30FC\u30B6\u30FC\u3092\u7279\u5B9A\u53EF\u80FD\u306A\u500B\u4EBA\u60C5\u5831\u7B49\u3092\u542B\u3080\u60C5\u5831(\u4F46\u3057\u3001\u5229\u7528\u767B\u9332\u306B\u5FC5\u8981\u306A\u5834\u5408\u7B49\u5F53\u793E\u304C\u6C42\u3081\u305F\u5834\u5408\u3001\u305D\u306E\u4ED6\u5F53\u793E\u304C\u8A8D\u3081\u305F\u5834\u5408\u3092\u9664\u304D\u307E\u3059\u3002\uFF09'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u30A6 \u904E\u5EA6\u306B\u308F\u3044\u305B\u3064\u306A\u8868\u73FE\uFF08\u6027\u7684\u306A\u4E8B\u7269\u3092\u9023\u60F3\u3055\u305B\u308B\u3068\u5F53\u793E\u304C\u5224\u65AD\u3057\u305F\u8868\u73FE\u3092\u3044\u3044\u3001\u82B8\u8853\u6027\u306E\u6709\u7121\u3092\u554F\u3044\u307E\u305B\u3093\u3002)\u3092\u542B\u3080\u60C5\u5831'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u30A8 \u7570\u6027\u3001\u540C\u6027\u3092\u554F\u308F\u305A\u3001\u9762\u8B58\u306E\u306A\u3044\u7B2C\u4E09\u8005\u3068\u306E\u51FA\u4F1A\u3044\u307E\u305F\u306F\u308F\u3044\u305B\u3064\u306A\u884C\u70BA\u7B49\u3092\u76EE\u7684\u3068\u3059\u308B\u60C5\u5831'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u30AA \u81EA\u6BBA\u3001\u81EA\u50B7\u884C\u70BA\u3092\u8A98\u5F15\u3001\u52E7\u8A98\u307E\u305F\u306F\u52A9\u9577\u3059\u308B\u307E\u305F\u306F\u8868\u73FE\u3092\u542B\u3080\u60C5\u5831'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u529B \u85AC\u7269\u30FB\u5371\u967A\u30C9\u30E9\u30C3\u30B0\u306E\u58F2\u8CB7\u306B\u95A2\u3059\u308B\u60C5\u5831\u307E\u305F\u306F\u85AC\u7269\u30FB\u5371\u967A\u30C9\u30E9\u30C3\u30B0\u306E\u4E0D\u9069\u5207\u306A\u5229\u7528\u3092\u52A9\u9577\u3059\u308B\u8868\u73FE\u3092\u542B\u3080\u60C5\u5831'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u30AD \u5B97\u6559\u7684\u884C\u70BA\u3001\u5B97\u6559\u56E3\u4F53\u3001\u653F\u6CBB\u7684\u6D3B\u52D5\u3001\u653F\u6CBB\u56E3\u4F53\u306E\u5BA3\u4F1D\u307E\u305F\u306F\u5E83\u544A\u306B\u95A2\u3059\u308B\u60C5\u5831'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u30AF \u7121\u9650\u9023\u9396\u8B1B\u3001\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF\u30D3\u30B8\u30CD\u30B9\u95A2\u9023\u306E\u52E7\u8A98\u7B49\u306B\u95A2\u3059\u308B\u60C5\u5831'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u30B1 \u30B8\u30E3\u30F3\u30AF\u30E1\u30FC\u30EB\u3001\u30B9\u30D1\u30E0\u30E1\u30FC\u30EB\u306B\u76F8\u5F53\u3059\u308B\u6587\u9762\u3092\u542B\u3080\u60C5\u5831'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u30B3 \u672A\u6210\u5E74\u8005\u306B\u60AA\u5F71\u97FF\u3092\u53CA\u307C\u3059\u304A\u305D\u308C\u306E\u3042\u308B\u60C5\u5831'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u30B5 \u6B8B\u865A\u306A\u8868\u73FE\u305D\u306E\u4ED6\u4ED6\u4EBA\u306B\u4E0D\u5FEB\u611F\u3092\u4E0E\u3048\u308B\u304A\u305D\u308C\u306E\u3042\u308B\u60C5\u5831'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u30B7 \u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30A6\u30A3\u30EB\u30B9\u7B49\u306E\u6709\u5BB3\u306A\u30D7\u30ED\u30B0\u30E9\u30E0\u3092\u6D41\u5E03\u3055\u305B\u308B\u60C5\u5831'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u30B9 \u305D\u306E\u4ED6\u5F53\u793E\u304C\u4E0D\u9069\u5207\u3068\u5224\u65AD\u3059\u308B\u6115\u5831'
	      ),
	      _react2.default.createElement(
	        'ol',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            '\u5229\u7528\u8005\u306F\u3001\u672C\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u500B\u4EBA\u3067\u8996\u8074\u3059\u308B\u76EE\u7684\u306B\u9650\u3063\u3066\u8996\u8074\u3057\u3001\u4EE5\u4E0B\u306E\u884C\u70BA\u3092\u81EA\u3089\u307E\u305F\u306F\u7B2C\u4E09\u8005\u3092\u901A\u3058\u3066\u884C\u3063\u3066\u306F\u3044\u3051\u307E\u305B\u3093\u3002'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            '\u672C\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u4E0D\u7279\u5B9A\u307E\u305F\u306F\u591A\u6570\u306E\u4EBA\u306B\u8996\u8074\u3055\u305B\u308B\u884C\u70BA'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            '\u672C\u30B5\u30FC\u30D3\u30B9\u306B\u3088\u308A\u914D\u4FE1\u3055\u308C\u308B\u6620\u50CF\u3001\u97F3\u58F0\u3001\u6587\u5B57\u7B49\u3092\u8457\u4F5C\u6A29\u6CD5\u3067\u8A8D\u3081\u3089\u308C\u305F\u79C1\u7684\u5229\u7528\u306E\u7BC4\u56F2\u3092\u8D85\u3048\u3066\u3001\u8907\u88FD\u3001\u51FA\u7248\u3001\u4E0A\u6620\u3001\u8B72\u6E21\u3001\u516C\u8846\u9001\u4FE1\u3001\u6539\u5909\u305D\u306E\u4ED6\u306E\u614B\u69D8\u3067\u5229\u7528\u3059\u308B\u884C\u70BA'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '5 \u672C\u30B5\u30FC\u30D3\u30B9\u307E\u305F\u306F\u672C\u30B3\u30F3\u30C6\u30F3\u30C4\u306B\u65BD\u3055\u308C\u3066\u3044\u308B\u30B3\u30F3\u30C6\u30F3\u30C4\u4FDD\u8B77\u6280\u8853\u3092\u6539\u5909\u305D\u306E\u4ED6\u306E\u65B9\u6CD5\u306B\u3088\u3063\u3066\u7121\u52B9\u306B\u3059\u308B\u884C\u70BA'
	      ),
	      _react2.default.createElement(
	        'ol',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            '\u672C\u30B5\u30FC\u30D3\u30B9\u306B\u304A\u3051\u308B\u30B3\u30F3\u30C6\u30F3\u30C4\u914D\u4FE1\u30B5\u30FC\u30D3\u30B9\u306E\u5229\u7528\u3001\u30EC\u30D3\u30E5\u30FC\u6A5F\u80FD\u306E\u5229\u7528\u305D\u306E\u4ED6\u306E\u30B5\u30FC\u30D3\u30B9\u5229\u7528\u306B\u304A\u3044\u3066\u3001\u682A\u5F0F\u4F1A\u793Eabasaku\u307E\u305F\u306F\u7B2C\u4E09\u8005\u306E\u77E5\u7684\u8CA1\u7523\u6A29\u3001\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u3001\u8096\u50CF\u6A29\u7B49\u3092\u4FB5\u5BB3\u3059\u308B\u884C\u70BA'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            '\u682A\u5F0F\u4F1A\u793Eabasaku\u306E\u901A\u4FE1\u8A2D\u5099\u3001\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u305D\u306E\u4ED6\u306E\u6A5F\u5668\u304A\u3088\u3073\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u306B\u4E0D\u6B63\u306B\u30A2\u30AF\u30BB\u30B9\u3057\u3001\u307E\u305F\u306F\u3001\u305D\u308C\u3089\u306E\u5229\u7528\u3082\u3057\u304F\u306F\u904B\u7528\u306B\u652F\u969C\u3092\u4E0E\u3048\u308B\u884C\u70BA\u3082\u3057\u304F\u306F\u305D\u306E\u304A\u305D\u308C\u306E\u3042\u308B\u884C\u70BA'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            '\u672C\u30B5\u30FC\u30D3\u30B9\u304C\u30EC\u30D3\u30E5\u30FC\u7B49\u306E\u66F8\u304D\u8FBC\u307F\u6A5F\u80FD\u3092\u6709\u3059\u308B\u5834\u5408\u306B\u304A\u3044\u3066\u3001\u5229\u7528\u8005\u307E\u305F\u306F\u7B2C\u4E09\u8005\u306E\u55B6\u5229\u3092\u76EE\u7684\u3068\u3059\u308B\u5229\u7528\u884C\u70BA'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            '\u4E0A\u8A18\u306E\u307B\u304B\u3001\u6CD5\u4EE4\u306B\u9055\u53CD\u3059\u308B\u884C\u70BA\u3001\u672C\u30B5\u30FC\u30D3\u30B9\u306E\u904B\u55B6\u3092\u59A8\u5BB3\u3059\u308B\u884C\u70BA\u3001\u682A\u5F0F\u4F1A\u793Eabasaku\u306E\u4FE1\u7528\u3092\u6BC0\u640D\u3059\u308B\u884C\u70BA\u305D\u306E\u4ED6\u682A\u5F0F\u4F1A\u793Eabasaku\u304C\u4E0D\u9069\u5F53\u3068\u5224\u65AD\u3059\u308B\u884C\u70BA'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '9-1 \u672C\u30B5\u30FC\u30D3\u30B9\u306E\u5185\u5916\u3092\u554F\u308F\u305A\u3001\u672C\u30B5\u30FC\u30D3\u30B9\u306B\u95A2\u9023\u3059\u308B\u30A4\u3079\u30F3\u30C8\u306E\u958B\u50AC\u307E\u305F\u306F\u30B0\u30C3\u30BA\u306E\u8CA9\u58F2\u7B49\u3001\u672C\u30B5\u30FC\u30D3\u30B9\u304C\u610F\u56F3\u3057\u306A\u3044\u65B9\u6CD5\u3067\u5229\u76CA\u3092\u5F97\u308B\u3053\u3068\u3092\u76EE\u7684\u3068\u3059\u308B\u884C\u70BA'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '9-2 \u672C\u30B5\u30FC\u30D3\u30B9\u3092\u9006\u30A2\u30BB\u30F3\u30D6\u30EB\uFF0C\u9006\u30B3\u30F3\u30D1\u30A4\u30EB\u3001\u30EA\u30D0\u30FC\u30B9\u30A8\u30F3\u30B8\u30CB\u30A2\u30EA\u30F3\u30B0\u3001\u305D\u306E\u4ED6\u672C\u30B5\u30FC\u30D3\u30B9\u306E\u30BD\u30FC\u30B9\u30B3\u30FC\u30C9\u3092\u89E3\u6790\u3059\u308B\u884C\u70BA'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '9-3 \u672C\u30B5\u30FC\u30D3\u30B9\u306B\u63A5\u7D9A\u3057\u3066\u3044\u308B\u30B7\u30B9\u30C6\u30E0\u306B\u6A29\u9650\u306A\u304F\u4E0D\u6B63\u306B\u30A2\u30AF\u30BB\u30B9\u3057\u307E\u305F\u306F\u5F53\u793E\u8A2D\u5099\u306B\u84C4\u7A4D\u3055\u308C\u305F\u60C5\u5831\u3092\u4E0D\u6B63\u306B\u66F8\u304D\u63DB\u3048\u82E5\u3057\u304F\u306F\u6D88\u53BB\u3059\u308B\u884C\u70BA'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '9-4 \u672C\u30B5\u30FC\u30D3\u30B9\u3092\u8907\u88FD\u3001\u9001\u4FE1\u3001\u7A63\u6E21\u3001\u8CB8\u4E0E\u307E\u305F\u306F\u6539\u5909\u3059\u308B\u884C\u70BA'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '9-5 \u6545\u610F\u306B\u865A\u507D\u306E\u30C7\u30FC\u30BF\u7B49\u3092\u516C\u958B\u3057\u307E\u305F\u306F\u6295\u7A3F\u3059\u308B\u884C\u70BA'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '9-6 \u4E0D\u6B63\u306A\u4F4D\u7F6E\u60C5\u5831\u3092\u767B\u7DD1\u3059\u308B\u884C\u70BA'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '9-7 \u5F53\u793E\u307E\u305F\u306F\u4ED6\u306E\u30E6\u30FC\u30B6\u30FC\u306E\u60C5\u5831\u306E\u53CE\u96C6\u3092\u76EE\u7684\u3068\u3059\u308B\u884C\u70BA'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '9-8 \u5F53\u793E\u307E\u305F\u306F\u4ED6\u306E\u30E6\u30FC\u30B6\u30FC\u305D\u306E\u4ED6\u306E\u7B2C\u4E09\u8005\u306B\u6210\u308A\u3059\u307E\u3059\u884C\u70BA'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '9-9 \u4ED6\u306E\u30E6\u30FC\u30B6\u30FC\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u5229\u7528\u3059\u308B\u884C\u70BA'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '9-10 \u672C\u30B5\u30FC\u30D3\u30B9\u4E0A\u3067\u306E\u5B9C\u4F1D\u3001\u5E83\u544A\u307E\u305F\u306F\u52E7\u8A98\u884C\u70BA'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '9-11 \u53CD\u793E\u4F1A\u7684\u52E2\u529B\u7B49\u3078\u306E\u5229\u76CA\u4F9B\u4E0E\u884C\u70BA'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '9-12 \u305D\u306E\u4ED6\u5F53\u793E\u304C\u4E0D\u9069\u5207\u3068\u5224\u65AD\u3059\u308B\u884C\u70BA'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '\u7B2C13\u6761 \u6A29\u5229\u306E\u5E30\u5C5E'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF11. \u672C\u30B5\u30FC\u30D3\u30B9\u53CA\u3073\u3001\u672C\u30B5\u30FC\u30D3\u30B9\u5185\u306E\u30A2\u30A4\u30C6\u30E0\u305D\u306E\u4ED6\u306E\u63D0\u4F9B\u30B3\u30F3\u30C6\u30F3\u30C4\u306B\u95A2\u3059\u308B\u4E00\u5207\u306E\u77E5\u7684\u8CA1\u7523\u6A29\u306F\u3001\u5F53\u793E\u307E\u305F\u306F\u5F53\u793E\u306B\u30E9\u30A4\u30BB\u30F3\u30B9\u3092\u8A31\u8AFE\u3057\u3066\u3044\u308B\u8005\u306B\u5E30\u5C5E\u3057\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '2.\u5229\u7528\u8005\u306F\u3001\u5F53\u793E\u304C\u672C\u30B5\u30FC\u30D3\u30B9\u5185\u3067\u8A31\u8AFE\u3059\u308B\u5229\u7528\u7BC4\u56F2\u3092\u8D85\u3048\u3066\u3001\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u5229\u7528\uFF08\u8EE2\u8F09\u30FB\u8907\u88FD\u30FB\u4FEE\u6B63\u30FB\u84C4\u7A4D\u307E\u305F\u306F\u8EE2\u9001\u7B49\uFF09\u3057\u3066\u306F\u306A\u3089\u306A\u3044\u3082\u306E\u3068\u3057\u307E\u3059\u3002\u306A\u304A\u3001\u5229\u7528\u8005\u306F\u3001\u5F53\u793E\u304C\u30B3\u30F3\u30C6\u30F3\u30C4\u306E\u5229\u7528\u6761\u4EF6\u3092\u5FC5\u8981\u306B\u5FDC\u3058\u3066\u5909\u66F4\u3059\u308B\u5834\u5408\u304C\u3042\u308B\u3053\u3068\u3001\u53CA\u3073\u5F53\u8A72\u5229\u7528\u6761\u4EF6\u306E\u5909\u66F4\u5185\u5BB9\u306B\u3088\u3063\u3066\u306F\u3001\u8A72\u5F53\u30B3\u30F3\u30C6\u30F3\u30C4\u306E\u524A\u9664\u3001\u5229\u7528\u505C\u6B62\u7B49\u3001\u5F53\u793E\u304C\u5FC5\u8981\u3068\u5224\u65AD\u3059\u308B\u63AA\u7F6E\u3092\u3068\u308B\u5834\u5408\u304C\u3042\u308B\u3053\u3068\u3092\u3001\u3042\u3089\u304B\u3058\u3081\u627F\u8AFE\u3059\u308B\u3082\u306E\u3068\u3057\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF13.\u30E6\u30FC\u30B6\u30FC\u306F\u3001\u5168\u3066\u306E\u63D0\u4F9B\u30B3\u30F3\u30C6\u30F3\u30C4\u306B\u95A2\u3057\u3001\u5F53\u793E\u306E\u6545\u610F\u307E\u305F\u306F\u91CD\u904E\u5931\u4EE5\u5916\u306E\u4E8B\u7531\u306B\u304A\u3044\u3066\u640D\u5BB3\u3092\u88AB\u3063\u305F\u5834\u5408\u3001\u5F53\u793E\u306B\u8FD4\u91D1\u307E\u305F\u306F\u88DC\u511F\u3092\u8ACB\u6C42\u3057\u306A\u3044\u3053\u3068\u306B\u540C\u610F\u3059\u308B\u3082\u306E\u3068\u3057\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF14.\u672C\u30B5\u30FC\u30D3\u30B9\u4E0A\u3001\u5546\u6A19\u3001\u30D6\u30E9\u30F3\u30C9\u30ED\u30B4\u7B49\uFF08\u4EE5\u4E0B\u3001\u7DCF\u79F0\u3057\u3066\u300C\u5546\u6A19\u7B49\u300D\u3068\u3044\u3044\u307E\u3059\u3002)\u304C\u8868\u793A\u3055\u308C\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u304C\u3001\u5F53\u793E\u306F\u30E6\u30FC\u30B6\u30FC\u305D\u306E\u4ED6\u306E\u7B2C\u4E09\u8005\u306B\u5BFE\u3057\u3001\u5546\u6A19\u7B49\u3092\u8B72\u6E21\u307E\u305F\u306F\u305D\u306E\u5229\u7528\u3092\u8A31\u8AFE\u3059\u308B\u3082\u306E\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u3002'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '\u7B2C14\u6761 \u898F\u7D04\u9055\u53CD\u306B\u5BFE\u3059\u308B\u63AA\u7F6E'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF11.\u5F53\u793E\u306F\u3001\u30E6\u30FC\u30B6\u30FC\u304C\u4EE5\u4E0B\u5404\u53F7\u306B\u8A72\u5F53\u3057\u307E\u305F\u306F\u8A72\u5F53\u3059\u308B\u304A\u305D\u308C\u304C\u3042\u308B\u3068\u5F53\u793E\u304C\u5224\u65AD\u3057\u305F\u5834\u5408\u306B\u306F\u3001\u5F53\u793E\u306E\u88C1\u91CF\u306B\u3088\u308A\u3001\u4F55\u3089\u306E\u901A\u77E5\u3082\u884C\u3046\u3053\u3068\u306A\u304F\u3001\u5F53\u6838\u30E6\u30FC\u30B6\u30FC\u306B\u5BFE\u3057\u3001\u30E6\u30FC\u30B6\u30FC\u30B3\u30F3\u30C6\u30F3\u30C4\u305D\u306E\u4ED6\u306E\u60C5\u5831\u306E\u5168\u90E8\u82E5\u3057\u304F\u306F\u4E00\u90E8\u306E\u524A\u9664\u3001\u672C\u30B5\u30FC\u30D3\u30B9\u306E\u5229\u7528\u306E\u4E00\u6642\u505C\u6B62\u82E5\u3057\u304F\u306F\u5236\u9650\u3001\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u524A\u9664\u3092\u542B\u3080\u672C\u5229\u7528\u5951\u7D04\u306E\u89E3\u9664\u7B49\u306E\u63AA\u7F6E\uFF08\u4EE5\u4E0B\u300C\u5229\u7528\u505C\u6B62\u7B49\u300D\u3068\u3044\u3044\u307E\u3059\u3002)\u3092\u8B1B\u3058\u308B\u3053\u3068\u304C\u3067\u304D\u308B\u3082\u306E\u3068\u3057\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '1-1 \u672C\u898F\u7D04\u306E\u3044\u305A\u308C\u304B\u306E\u6761\u9805\u306B\u9055\u53CD\u3057\u305F\u5834\u5408'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '1-2 \u5F53\u793E\u306B\u63D0\u4F9B\u3055\u308C\u305F\u60C5\u5831\u306E\u5168\u90E8\u307E\u305F\u306F\u4E00\u90E8\u306B\u3064\u304D\u865A\u507D\u306E\u4E8B\u5B9F\u304C\u3042\u308B\u3053\u3068\u304C\u5224\u660E\u3057\u305F\u5834\u5408'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '1-3 \u30E6\u30FC\u30B6\u30FC\u304C\u652F\u6255\u505C\u6B62\u82E5\u3057\u304F\u306F\u652F\u6255\u4E0D\u80FD\u3068\u306A\u308A\u3001\u307E\u305F\u306F\u7834\u7523\u624B\u7D9A\u958B\u59CB\u3001\u6C11\u4E8B\u518D\u751F\u624B\u7D9A\u958B\u59CB\u3001\u4F1A\u793E\u66F4\u751F\u624B\u7D9A\u958B\u59CB\u3001\u7279\u5225\u6E05\u7B97\u958B\u59CB\u82E5\u3057\u304F\u306F\u3053\u308C\u3089\u306B\u985E\u3059\u308B\u624B\u7D9A\u306E\u958B\u59CB\u306E\u7533\u7ACB\u3066\u304C\u3042\u3063\u305F\u5834\u5408'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '1-4 \u30E6\u30FC\u30B6\u30FC\u304C\u6B7B\u4EA1\u3057\u307E\u305F\u306F\u5F8C\u898B\u958B\u6D3B\u3001\u4FDD\u4F50\u958B\u59CB\u82E5\u3057\u304F\u306F\u88DC\u52A9\u958B\u59CB\u306E\u5BE9\u5224\u3092\u53D7\u3051\u305F\u5834\u5408'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '1-5 \u672A\u6210\u5E74\u8005\u3001\u6210\u5E74\u88AB\u5F8C\u898B\u4EBA\u3001\u88AB\u4FDD\u4F50\u4EBA\u307E\u305F\u306F\u88AB\u88DC\u52A9\u4EBA\u306E\u3044\u305A\u308C\u304B\u3067\u3042\u3063\u3066\u3001\u6CD5\u5B9A\u4EE3\u7406\u4EBA\u3001\u5F8C\u898B\u4EBA\u3001\u4FDD\u4F50\u4EBA\u307E\u305F\u306F\u88DC\u52A9\u4EBA\u306E\u540C\u610F\u7B49\u3092\u5F97\u3066\u3044\u306A\u304B\u3063\u305F\u5834\u5408'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '1-6 \u5F53\u793E\u304B\u3089\u306E\u554F\u3044\u5408\u308F\u305B\u305D\u306E\u4ED6\u306E\u56DE\u7B54\u3092\u6C42\u3081\u308B\u9023\u7D61\u306B\u5BFE\u3057\u3066\uFF13\uFF10\u65E5\u9593\u4EE5\u4E0A\u5FDC\u7B54\u304C\u306A\u3044\u5834\u5408'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '1-7 \u53CD\u793E\u4F1A\u7684\u52E2\u529B\u7B49\u3067\u3042\u308B\u304B\u3001\u307E\u305F\u306F\u8CC7\u91D1\u63D0\u4F9B\u305D\u306E\u4ED6\u3092\u901A\u3058\u3066\u53CD\u793E\u4F1A\u7684\u52E2\u529B\u7B49\u306E\u7DAD\u6301\u3001\u904B\u55B6\u82E5\u3057\u304F\u306F\u7D4C\u55B6\u306B\u5354\u529B\u82E5\u3057\u304F\u306F\u95A2\u4E0E\u3059\u308B\u7B49\u3001\u53CD\u793E\u4F1A\u7684\u52E2\u529B\u7B49\u3068\u306E\u4F55\u3089\u304B\u306E\u4EA4\u6D41\u82E5\u3057\u304F\u306F\u95A2\u4E0E\u3092\u884C\u3063\u3066\u3044\u308B\u3068\u5F53\u793E\u304C\u5224\u65AD\u3057\u305F\u5834\u5408'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '1-8 \u672C\u30B5\u30FC\u30D3\u30B9\u306E\u904B\u55B6\u3001\u4FDD\u5B88\u7BA1\u7406\u4E0A\u5FC5\u8981\u3067\u3042\u308B\u3068\u5F53\u793E\u304C\u5224\u65AD\u3057\u305F\u5834\u5408'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '1-9 \u305D\u306E\u4ED6\u524D\u5404\u53F7\u306B\u985E\u3059\u308B\u4E8B\u7531\u304C\u3042\u308B\u3068\u5F53\u793E\u304C\u5224\u65AD\u3057\u305F\u5834\u5408'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF12.\u30E6\u30FC\u30B6\u30FC\u306F\u3001\u5229\u7528\u505C\u6B62\u7B49\u306E\u5F8C\u3082\u3001\u5F53\u793E\u53CA\u3073\u7B2C\u4E09\u8005\u306B\u5BFE\u3059\u308B\u672C\u5229\u7528\u5951\u7D04\u4E0A\u306E\u4E00\u5207\u306E\u7FA9\u52D9\u53CA\u3073\u50B5\u52D9\uFF08\u640D\u5BB3\u8CE0\u511F\u50B5\u52D9\u3092\u542B\u307F\u307E\u3059\u304C\u3001\u3053\u308C\u306B\u9650\u308A\u307E\u305B\u3093\u3002\uFF09\u3092\u514D\u308C\u308B\u3082\u306E\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF13.\u5F53\u793E\u306F\u3001\u672C\u6761\u306B\u57FA\u3065\u304D\u5F53\u793E\u304C\u884C\u3063\u305F\u884C\u70BA\u306B\u3088\u308A\u30E6\u30FC\u30B6\u30FC\u306B\u751F\u3058\u305F\u640D\u5BB3\u306B\u3064\u3044\u3066\u4E00\u5207\u306E\u8CAC\u4EFB\u3092\u8CA0\u308F\u305A\u3001\u30E6\u30FC\u30B6\u30FC\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u524A\u9664\u5F8C\u3082\u3001\u5F53\u8A72\u30E6\u30FC\u30B6\u30FC\u304C\u5F53\u793E\u306B\u63D0\u4F9B\u3057\u305F\u60C5\u5831\u3092\u4FDD\u6709\u30FB\u5229\u7528\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u308B\u3082\u306E\u3068\u3057\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF14.\u5F53\u793E\u306F\u3001\u30E6\u30FC\u30B6\u30FC\u304C\u7B2C\uFF11\u9805\u5404\u53F7\u306B\u8A72\u5F53\u3057\u307E\u305F\u306F\u8A72\u5F53\u3059\u308B\u304A\u305D\u308C\u304C\u3042\u308B\u3068\u5F53\u793E\u304C\u5224\u65AD\u3057\u305F\u5834\u5408\u305D\u306E\u4ED6\u5F53\u793E\u304C\u5FC5\u8981\u3068\u8A8D\u3081\u308B\u5834\u5408\u306B\u306F\u3001\u30E6\u30FC\u30B6\u30FC\u306B\u5BFE\u3057\u3001\u9055\u53CD\u884C\u70BA\u306E\u4E2D\u6B62\u3001\u9001\u4FE1\u307E\u305F\u306F\u6295\u7A3F\u3057\u305F\u60C5\u5831\u306E\u81EA\u767A\u7684\u306A\u524A\u9664\u30FB\u8A02\u6B63\u7B49\u3092\u6C42\u3081\u308B\u3053\u3068\u304C\u3042\u308A\u3001\u30E6\u30FC\u30B6\u30FC\u306F\u3001\u5F53\u793E\u304C\u5B9A\u3081\u308B\u671F\u9593\u5185\u306B\u5F53\u8A72\u6C42\u3081\u306B\u5FDC\u3058\u308B\u3082\u306E\u3068\u3057\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF15.\u5F53\u793E\u306F\u3001\u672C\u6761\u306B\u57FA\u3065\u304D\u5F53\u793E\u304C\u884C\u3063\u305F\u63AA\u7F6E\u306B\u3088\u308A\u30E6\u30FC\u30B6\u30FC\u306B\u751F\u3058\u305F\u4E0D\u5229\u76CA\u3084\u640D\u5BB3\u306B\u3064\u3044\u3066\u4E00\u5207\u306E\u8CAC\u4EFB\u3092\u8CA0\u3044\u307E\u305B\u3093\u3002'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '\u7B2C\uFF115\u6761 \u640D\u5BB3\u8CE0\u511F'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF11.\u30E6\u30FC\u30B6\u30FC\u306B\u3088\u308B\u672C\u898F\u7D04\u9055\u53CD\u884C\u70BA\u305D\u306E\u4ED6\u672C\u30B5\u30FC\u30D3\u30B9\u306E\u5229\u7528\u306B\u8D77\u56E0\u3057\u3066\u3001\u5F53\u793E\u306B\u76F4\u63A5\u307E\u305F\u306F\u9593\u63A5\u306E\u640D\u5BB3\u304C\u751F\u3058\u305F\u6E6F\u5408\uFF08\u5F53\u8A72\u884C\u70BA\u304C\u539F\u56E0\u3067\u3001\u5F53\u793E\u304C\u7B2C\u4E09\u8005\u304B\u3089\u640D\u5BB3\u8CE0\u511F\u8ACB\u6C42\u305D\u306E\u4ED6\u306E\u8AF8\u6C42\u3092\u53D7\u3051\u305F\u5834\u5408\u3092\u542B\u307F\u307E\u3059\u3002\uFF09\u3001\u30E6\u30FC\u30B6\u30FC\u306F\u3001\u5F53\u793E\u306B\u5BFE\u3057\u3001\u305D\u306E\u5168\u3066\u306E\u640D\u5BB3\uFF08\u5F01\u8B77\u58EB\u7B49\u5C02\u9580\u5BB6\u8CBB\u7528\u53CA\u3073\u5F53\u793E\u306B\u304A\u3044\u3066\u5BFE\u5FDC\u306B\u8981\u3057\u305F\u4EBA\u4EF6\u8CBB\u76F8\u5F53\u984D\u3092\u542B\u307F\u307E\u3059\u3002\uFF09\u3092\u8CE0\u511F\u3057\u306A\u3051\u308C\u3070\u306A\u308A\u307E\u305B\u3093\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF12.\u672C\u30B5\u30FC\u30D3\u30B9\u306E\u5229\u7528\u306B\u95A2\u9023\u3057\u3066\u30E6\u30FC\u30B6\u30FC\u304C\u88AB\u3063\u305F\u640D\u5BB3\u306B\u3064\u304D\u3001\u5F53\u793E\u304C\u3001\u8EFD\u5EA6\u306E\u904E\u5931\u306B\u3088\u308B\u50B5\u52D9\u4E0D\u5C65\u884C\u8CAC\u4EFB\u307E\u305F\u306F\u4E0D\u6CD5\u884C\u70BA\u8CAC\u4EFB\u3092\u8CA0\u3046\u5834\u5408\u306B\u306F\u3001\u5F53\u793E\u306F\u3001\u30E6\u30FC\u30B6\u30FC\u306B\u73FE\u5B9F\u306B\u767A\u751F\u3057\u305F\u76F4\u63A5\u304B\u3064\u901A\u5E38\u306E\u640D\u5BB3\u306B\u9650\u308A\u3001\u3053\u308C\u3092\u8CE0\u511F\u3059\u308B\u8CAC\u4EFB\u3092\u8CA0\u3046\u3082\u306E\u3068\u3057\u3001\u7279\u5225\u306A\u4E8B\u60C5\u304B\u3089\u751F\u3058\u305F\u640D\u5BB3\uFF08\u640D\u5BB3\u306E\u767A\u751F\u3092\u4E88\u898B\u3057\u307E\u305F\u306F\u4E88\u898B\u3057\u5F97\u305F\u5834\u5408\u3092\u542B\u307F\u307E\u3059\u3002\uFF09\u306B\u3064\u3044\u3066\u306F\u3001\u8CAC\u4EFB\u3092\u8CA0\u308F\u306A\u3044\u3082\u306E\u3068\u3057\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '\u7B2C16\u6761 \u79D8\u5BC6\u4FDD\u6301'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF11.\u30E6\u30FC\u30B6\u30FC\u306F\u3001\u5F53\u793E\u306E\u4E8B\u524D\u306E\u66F8\u9762\u306B\u3088\u308B\u627F\u8AFE\u304C\u3042\u308B\u5834\u5408\u3092\u9664\u304D\u3001\u672C\u30B5\u30FC\u30D3\u30B9\u306B\u95A2\u9023\u3057\u3066\u5F53\u793E\u304C\u79D8\u5BC6\u3067\u3042\u308B\u65E8\u6307\u5B9A\u3057\u305F\u60C5\u5831\u3092\u79D8\u5BC6\u306B\u53D6\u308A\u6271\u3046\u3082\u306E\u3068\u3057\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF12.\u30E6\u30FC\u30B6\u30FC\u306F\u3001\u5F53\u793E\u304B\u3089\u6C42\u3081\u3089\u308C\u305F\u5834\u5408\u306F\u3044\u3064\u3067\u3082\u3001\u5F53\u793E\u306E\u6307\u793A\u306B\u5F93\u3044\u3001\u9045\u6EDE\u306A\u304F\u3001\u524D\u9805\u306E\u60C5\u5831\u53CA\u3073\u5F53\u8A72\u60C5\u5831\u3092\u8A18\u8F09\u307E\u305F\u306F\u8A18\u9332\u3057\u305F\u66F8\u9762\u305D\u306E\u4ED6\u306E\u8A18\u9332\u5A92\u4F53\u7269\u4E26\u3073\u306B\u305D\u306E\u5168\u3066\u306E\u8907\u88FD\u7269\u7B49\u3092\u8FD4\u5374\u307E\u305F\u306F\u5EC3\u68C4\u3057\u306A\u3051\u308C\u3070\u306A\u308A\u307E\u305B\u3093\u3002'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '\u7B2C17\u6761 \u672C\u30B5\u30FC\u30D3\u30B9\u306E\u5229\u7528\u7D42\u4E86'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF11.\u30E6\u30FC\u30B6\u30FC\u306F\u3001\u5F53\u793E\u6240\u5B9A\u306E\u65B9\u6CD5\u306B\u3088\u308A\u3001\u3044\u3064\u3067\u3082\u672C\u30B5\u30FC\u30D3\u30B9\u306E\u5229\u7528\u3092\u7D42\u4E86\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002\u672C\u30B5\u30FC\u30D3\u30B9\u306E\u5229\u7528\u3092\u7D42\u4E86\u3057\u305F\u30E6\u30FC\u30B6\u30FC\u306F\u3001\u5F53\u8A72\u7D42\u4E86\u6642\u70B9\u304B\u3089\u672C\u30B5\u30FC\u30D3\u30B9\u3092\u5229\u7528\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u306A\u304F\u306A\u308A\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '2 .\u5F53\u793E\u306F\u3001\u5F53\u793E\u306E\u88C1\u91CF\u306B\u3088\u308A\u3001\u3042\u3089\u304B\u3058\u3081\u901A\u77E5\u3059\u308B\u3053\u3068\u306A\u304F\u3001\u6700\u7D42\u306E\u30A2\u30AF\u30BB\u30B9\u304B\u3089\uFF16\u304B\u6708\u4EE5\u4E0A\u7D4C\u904E\u3057\u3066\u3044\u308B\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u524A\u9664\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u308B\u3082\u306E\u3068\u3057\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '\u7B2C18\u6761 \u672C\u30B5\u30FC\u30D3\u30B9\u306E\u5909\u66F4\u30FB\u4E2D\u65AD\u30FB\u7D42\u4E86\u7B49'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF11.\u5F53\u793E\u306F\u3001\u30E6\u30FC\u30B6\u30FC\u306B\u4E8B\u524D\u306B\u901A\u77E5\u3059\u308B\u3053\u3068\u306A\u304F\u3001\u672C\u30B5\u30FC\u30D3\u30B9\u306E\u5185\u5BB9\u306E\u5168\u90E8\u307E\u305F\u306F\u4E00\u90E8\u3092\u5909\u66F4\u307E\u305F\u306F\u8FFD\u52A0\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u308B\u3082\u306E\u3068\u3057\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF12.\u5F53\u793E\u306F\u3001\u4E8B\u524D\u306B\u3001\u672C\u30B5\u30FC\u30D3\u30B9\u4E0A\u307E\u305F\u306F\u5F53\u793E\u306E\u904B\u55B6\u3059\u308B\u30A6\u30A7\u30D6\u30B5\u30A4\u30C8\u4E0A\u3078\u306E\u63B2\u793A\u305D\u306E\u4ED6\u306E\u5F53\u793E\u304C\u9069\u5F53\u3068\u5224\u65AD\u3059\u308B\u65B9\u6CD5\u3067\u30E6\u30FC\u30B6\u30FC\u306B\u901A\u77E5\u3059\u308B\u3053\u3068\u306B\u3088\u308A\u3001\u5F53\u793E\u306E\u88C1\u91CF\u3067\u3001\u672C\u30B5\u30FC\u30D3\u30B9\u306E\u63D0\u4F9B\u3092\u7D42\u4E86\u3059\u308B\u3053\u3068\u304B\u3067\u304D\u308B\u3082\u306E\u3068\u3057\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF13.\u5F53\u793E\u306F\u3001\u4EE5\u4E0B\u306E\u5404\u53F7\u306E\u4E8B\u7531\u304C\u751F\u3058\u305F\u5834\u5408\u306B\u306F\u3001\u30E6\u30FC\u30B6\u30FC\u306B\u4E8B\u524D\u306B\u901A\u77E5\u3059\u308B\u3053\u3068\u306A\u304F\u3001\u672C\u30B5\u30FC\u30D3\u30B9\u306E\u5168\u90E8\u307E\u305F\u306F\u4E00\u90E8\u3092\u4E00\u6642\u7684\u306B\u4E2D\u65AD\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u308B\u3082\u306E\u3068\u3057\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '3-1 \u672C\u30B5\u30FC\u30D3\u30B9\u7528\u306E\u901A\u4FE1\u6A5F\u5668\u8A2D\u5099\u7B49\u306B\u95A2\u308F\u308B\u30E1\u30F3\u30C6\u30CA\u30F3\u30B9\u3084\u4FEE\u7406\u3092\u5B9A\u671F\u7684\u307E\u305F\u306F\u7DCA\u6025\u306B\u884C\u3046\u5834\u5408'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '3-2 \u30A2\u30AF\u30BB\u30B9\u904E\u591A\u3001\u305D\u306E\u4ED6\u4E88\u671F\u305B\u306C\u8981\u56E0\u3067\u30B7\u30B9\u30C6\u30E0\u306B\u8CA0\u8377\u304C\u83B1\u4E2D\u3057\u305F\u5834\u5408'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '3-3 \u30E6\u30FC\u30B6\u30FC\u306E\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u3092\u78BA\u4FDD\u3059\u308B\u5FC5\u8981\u304C\u751F\u3058\u305F\u5834\u5408'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '3-4 \u96FB\u6C17\u901A\u4FE1\u4E8B\u696D\u8005\u306E\u5F79\u52D9\u304C\u63D0\u4F9B\u3055\u308C\u306A\u3044\u5834\u5408'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '3-5 \u5730\u9707\u3001\u6C34\u5BB3\u7B49\u306E\u5929\u707D\u3001\u706B\u707D\u3001\u505C\u96FB\u3001\u305D\u306E\u4ED6\u306E\u4E0D\u616E\u306E\u4E8B\u6545\u307E\u305F\u306F\u6226\u4E89\u3001\u7D1B\u4E89\u3001\u52D5\u4E71\u3001\u66B4\u52D5\u3001\u52B4\u50CD\u4E89\u8B70\u7B49\u306E\u4E0D\u53EF\u6297\u529B\u306B\u3088\u308A\u672C\u30B5\u30FC\u30D3\u30B9\u306E\u63D0\u4F9B\u304C\u56F0\u96E3\u306A\u5834\u5408'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '3-6 \u6CD5\u4EE4\u307E\u305F\u306F\u3053\u308C\u306B\u57FA\u3065\u304F\u63AA\u7F6E\u306B\u3088\u308A\u672C\u30B5\u30FC\u30D3\u30B9\u306E\u904B\u55B6\u304C\u4E0D\u80FD\u3068\u306A\u3063\u305F\u5834\u5408'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '3-7 \u305D\u306E\u4ED6\u524D\u5404\u53F7\u306B\u6E96\u3058\u5F53\u793E\u304C\u5FC5\u8981\u3068\u5224\u65AD\u3057\u305F\u5834\u5408'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF14.\u5F53\u793E\u306F\u3001\u672C\u6761\u306B\u57FA\u3065\u304D\u5F53\u793E\u304C\u884C\u3063\u305F\u63AA\u7F6E\u306B\u3088\u308A\u30E6\u30FC\u30B6\u30FC\u306B\u751F\u3058\u305F\u640D\u5BB3\u306B\u3064\u3044\u3066\u4E00\u5207\u306E\u8CAC\u4EFB\u3092\u8CA0\u3044\u307E\u305B\u3093\u3002'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '\u7B2C19\u6761 \u514D\u8CAC\u4E8B\u9805'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF11.\u5F53\u793E\u306F\u3001\u672C\u30B5\u30FC\u30D3\u30B9\u53CA\u3073\u672C\u30B5\u30FC\u30D3\u30B9\u3092\u901A\u3058\u3066\u63D0\u4F9B\u3055\u308C\u308B\u30B3\u30F3\u30C6\u30F3\u30C4\u305D\u306E\u4ED6\u4E00\u5207\u306E\u60C5\u5831\u306B\u3064\u304D\u3001\u30A8\u30E9\u30FC\u3001\u30D0\u30B0\u3001\u4E0D\u5177\u5408\u307E\u305F\u306F\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u4E0A\u306E\u6B20\u9665\u304C\u5B58\u3057\u306A\u3044\u3053\u3068\u3001\u7B2C\u4E09\u8005\u306E\u6A29\u5229\u3092\u4FB5\u5BB3\u3057\u306A\u3044\u3053\u3068\u3001\u30E6\u30FC\u30B6\u30FC\u304C\u671F\u5F85\u3059\u308B\u6027\u8CEA\u53CA\u3073\u5546\u54C1\u7684\u4FA1\u5024\u3092\u6709\u3059\u308B\u3053\u3068\u3001\u4E26\u3073\u306B\u30E6\u30FC\u30B6\u30FC\u306B\u9069\u7528\u306E\u3042\u308B\u6CD5\u4EE4\u6587\u306F\u5185\u90E8\u898F\u5247\u7B49\u306B\u9069\u5408\u3059\u308B\u3053\u3068\u306B\u3064\u3044\u3066\u3001\u5982\u4F55\u306A\u308B\u4FDD\u8A3C\u3082\u884C\u3046\u3082\u306E\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF12.\u5F53\u793E\u306F\u672C\u30B5\u30FC\u30D3\u30B9\u304C\u5168\u3066\u306E\u60C5\u5831\u7AEF\u672B\u306B\u5BFE\u5FDC\u3057\u3066\u3044\u308B\u3053\u3068\u3092\u4FDD\u8A3C\u3059\u308B\u3082\u306E\u3067\u306F\u306A\u304F\u3001\u672C\u30B5\u30FC\u30D3\u30B9\u306E\u5229\u7528\u306B\u4F9B\u3059\u308B\u60C5\u5831\u7AEF\u672B\u306EOS\u306E\u30D0\u30FC\u30B8\u30E7\u30F3\u30A2\u30C3\u30D7\u7B49\u306B\u4F34\u3044\u3001\u672C\u30B5\u30FC\u30D3\u30B9\u306E\u52D5\u4F5C\u306B\u4E0D\u5177\u5408\u304C\u751F\u3058\u308B\u53EF\u80FD\u6027\u304C\u3042\u308B\u3053\u3068\u306B\u3064\u304D\u3001\u30E6\u30FC\u30B6\u30FC\u306F\u3042\u3089\u304B\u3058\u3081\u4E86\u627F\u3059\u308B\u3082\u306E\u3068\u3057\u307E\u3059\u3002\u5F53\u793E\u306F\u3001\u304B\u304B\u308B\u4E0D\u8C9D\u5408\u304C\u751F\u3058\u305F\u5834\u5408\u306B\u5F53\u793E\u304C\u884C\u3046\u30D7\u30ED\u30B0\u30E9\u30E0\u306E\u4FEE\u6B63\u7B49\u306B\u3088\u308A\u3001\u5F53\u8A72\u4E0D\u5177\u5408\u304C\u89E3\u6D88\u3055\u308C\u308B\u3053\u3068\u3092\u4FDD\u8A3C\u3059\u308B\u3082\u306E\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '3.\u672C\u30B5\u30FC\u30D3\u30B9\u306B\u95A2\u3057\u3001\u30E6\u30FC\u30B6\u30FC\u9593\u307E\u305F\u306F\u30E6\u30FC\u30B6\u30FC\u3068\u7B2C\u4E09\u8005\u3068\u306E\u9593\u3067\u7D1B\u4E89\u304C\u751F\u3058\u305F\u5834\u5408\u3001\u30E6\u30FC\u30B6\u30FC\u306F\u3001\u5F53\u793E\u306B\u3053\u308C\u3092\u901A\u77E5\u306E\u4E0A\u3001\u81EA\u5DF1\u306E\u8CAC\u4EFB\u3068\u8CBB\u7528\u306B\u304A\u3044\u3066\u89E3\u6C7A\u3059\u308B\u3082\u306E\u3068\u3057\u307E\u3059\u3002 \u5F53\u793E\u306F\u3001\u5F53\u8A72\u7D1B\u4E89\u306B\u95A2\u4E0E\u3059\u308B\u7FA9\u52D9\u3092\u8CA0\u308F\u305A\u3001\u4F55\u3089\u8CAC\u4EFB\u3092\u8CA0\u308F\u306A\u3044\u3082\u306E\u3068\u3057\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '\u7B2C20\u6761 \u9023\u7D61\u53CA\u3073\u554F\u3044\u5408\u308F\u305B'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF11.\u672C\u30B5\u30FC\u30D3\u30B9\u306B\u95A2\u3059\u308B\u5F53\u793E\u304B\u3089\u306E\u30E6\u30FC\u30B6\u30FC\u30D8\u306E\u9023\u7D61\u306B\u95A2\u3057\u3066\u306F\u3001\u4E0B\u8A18\u306E\u65B9\u6CD5\u3067\u884C\u3044\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '1-1 \u672C\u30B5\u30FC\u30D3\u30B9\u4E0A\u82E5\u3057\u304F\u306F\u5F53\u793E\u304C\u904B\u55B6\u3059\u308B\u30A6\u30A7\u30D6\u30B5\u30A4\u30C8\u5185\u306E\u9069\u5B9C\u306E\u5834\u6240\u3078\u306E\u63B2\u793A 1-2 \u96FB\u5B50\u30E1\u30FC\u30EB\u306E\u9001\u4FE1 1-3 \u305D\u306E\u4ED6\u5F53\u793E\u304C\u9069\u5F53\u3068\u5224\u65AD\u3059\u308B\u65B9\u6CD5'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF12.\u5F53\u793E\u304C\u30E6\u30FC\u30B6\u30FC\u3078\u96FB\u5B50\u30E1\u30FC\u30EB\u306E\u9001\u4FE1\u306B\u3088\u308B\u901A\u77E5\u3092\u884C\u3063\u305F\u5834\u5408\u3001\u5F53\u793E\u304B\u3089\u901A\u77E5\u306F\u3001\u30E6\u30FC\u30B6\u30FC\u304C\u767B\u9332\u3057\u305F\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3078\u306E\u30E1\u30FC\u30EB\u9001\u4FE1\u3057\u3001\u305D\u308C\u3092\u30E6\u30FC\u30B6\u30FC\u304C\u53D7\u4FE1\u3057\u305F\u6642\u70B9\u3067\u5230\u9054\u3057\u305F\u3082\u306E\u3068\u307F\u306A\u3057\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF13.\u672C\u30B5\u30FC\u30D3\u30B9\u306B\u95A2\u3059\u308B\u554F\u3044\u5408\u308F\u305B\u306F\u3001\u5F53\u793E\u304C\u904B\u55B6\u3059\u308B\u30A6\u30A7\u30D6\u30B5\u30A4\u30C8\u5185\u306E\u5BFE\u8C61\u3068\u306A\u308B\u304A\u554F\u3044\u5408\u308F\u305B\u30D5\u30A9\u30FC\u30E0\u30D8\u306E\u9001\u4FE1\u305D\u306E\u4ED6\u3001\u5F53\u793E\u304C\u6307\u5B9A\u3059\u308B\u65B9\u6CD5\u306B\u3088\u308A\u884C\u3046\u3082\u306E\u3068\u3057\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '\u7B2C21\u6761 \u6E96\u62E0\u6CD5'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u672C\u30B5\u30FC\u30D3\u30B9\u305D\u306E\u4ED6\u306E\u672C\u898F\u7D04\u306B\u95A2\u3059\u308B\u6E96\u62E0\u6CD5\u306F\u65E5\u672C\u6CD5\u3068\u3057\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '\u7B2C22\u6761 \u7BA1\u8F44\u88C1\u5224\u6240'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u672C\u30B5\u30FC\u30D3\u30B9\u306B\u95A2\u3057\u3001\u30E6\u30FC\u30B6\u30FC\u3068\u5F53\u793E\u3068\u306E\u9593\u3067\u8A34\u8A1F\u304C\u751F\u3058\u305F\u5834\u5408\u3001\u6771\u4EAC\u5730\u65B9\u88C1\u5224\u6240\u3092\u7B2C\uFF11\u5BE9\u306E\u5C02\u5C5E\u7684\u7BA1\u8F44\u88C1\u5224\u6240\u3068\u3057\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u4EE5\u4E0A'
	      )
	    )
	  );
	};
	exports.default = Terms;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-terms-js-8555948ecd4bc434e7de.js